import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';
import { map } from 'rxjs/operators';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';

@Injectable()
export class ExactService {

    constructor(private http: HttpClient) {

    }

    exporteerDebiteur(klantId: number) {
        return this.http.post(`/api/exact/exporteerDebiteur?klantId=${klantId}`, null).pipe(map(x => x as ExporteerResponse));
    }

    exporteerFactuur(factuurId: number) {
        return this.http.post(`/api/exact/exporteerFactuur?klantId=${factuurId}`, null).pipe(map(x => x as ExporteerResponse));
    }

}

export interface ExporteerResponse {
    successful: boolean;
    message: string;
    number: number;
    exportNumber: number;
    failed: number;
}
